module.exports = __webpack_public_path__ + "img/emoji-expressionless-fill.ec7b441e.svg";